import { createDataSource } from './createModal'

const initState = {
    selectedClusterID: ''
}

export function growV2State() {
    window.localStorage.setItem('v2State', JSON.stringify(initState))
}
export function updateV2State(data) {
    window.localStorage.setItem('v2State', JSON.stringify(data))
}
export function removeV2State() {
    window.localStorage.setItem('v2State', JSON.stringify({}))
}
function checkV2State() {
    if (!window.localStorage.getItem('v2State')) {
        growV2State()
    }
    return null
}
checkV2State()
const { useSetGlobalState, setGlobalState } = createDataSource(JSON.parse(window.localStorage.getItem('v2State')) || {})
export { useSetGlobalState, setGlobalState }
